import { action } from '@ember/object';
import Component from '@glimmer/component';

import { DataSelectType } from 'webapp/enums/enums';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type { DataSelectProps } from 'webapp/models-custom/block-setup';
import type DataSelect from 'webapp/models-custom/data-select';
import MetricLimitations from 'webapp/models-custom/metric-limitations';
import type VisualizationNumber from 'webapp/models-custom/visualization/number';

interface Args {
	blockM: Block;
	dataSelect: DataSelect;
}

export default class BlockSettingsMetricShowSmallChartComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get visualization(): VisualizationNumber {
		return this.block.blockSetup.visualization as VisualizationNumber;
	}

	get chartDataSelect(): DataSelect | null {
		return (
			this.blockSetup.getSecondaryDataSelectsForDataSelect(this.args.dataSelect)[0] || null
		);
	}

	get selected(): boolean {
		return !!this.chartDataSelect;
	}

	@action
	changeSelected(selected: boolean): void {
		const chartDataSelect = this.chartDataSelect;
		if (chartDataSelect) {
			if (!selected) {
				this.blockSetup.deleteDataSelect(chartDataSelect);
			}
		} else {
			if (selected) {
				const model = this.args.dataSelect;

				if (!model.id) {
					return;
				}

				const dateRange = model.limitations.dateRange?.createCopy();
				const limitations = new MetricLimitations({
					metrics: model.metricData ? [model.metricData] : [],
					isNumber: false,
					dateRange,
				});
				limitations.selectOptimalValidGranulation();

				const props: DataSelectProps = {
					type: DataSelectType.MAIN,
					updateFrom: model.numericId,
					dateRange: limitations.dateRange?.formula,
				};
				const metricSetupData = model.metricSetupData;
				if (metricSetupData) {
					props.metricSetupKey = metricSetupData.key;
					props.metricSetupSpaceAccessId = metricSetupData.spaceAccessId;
					props.metricSetupDimensions = metricSetupData.dimensions;
					props.metricSetupFilters = metricSetupData.filters;
				}
				this.blockSetup.createDataSelect(props);
			}
		}
	}
	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="showSmallChart"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>Show small chart</label>
		</div>
	</template>
}
